import { render, staticRenderFns } from "./MerchantApplicationDetails.vue?vue&type=template&id=f240aa52"
import script from "./MerchantApplicationDetails.vue?vue&type=script&lang=js"
export * from "./MerchantApplicationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports